export default {"src":"/_next/static/media/white-brochure-icon.fc3eac76.svg","height":18,"width":24,"blurWidth":0,"blurHeight":0};